module.exports = __webpack_public_path__ + "img/ascend_gold13.117927d7.png";